import axios from "axios";

export const Client = axios.create({
  baseURL: "/.netlify/functions",
});

export const BlogClient = axios.create({
  withCredentials: true,
  baseURL: process.env.REACT_APP_SECRET_API,
});
